<template>
  <el-table-column
    v-bind="$attrs"
    :label="label"
    :column-key="filterName"
    :filters="usedTimeFilter"
    :filtered-value="filteredValue"
    :filter-multiple="false"
    align="center"
    >
    <template slot-scope="scope">
      <div
        v-if="scope.row.orders_delivery_id !== 0"
        >
        <el-popover
          trigger="click"
          >
          <el-table
            :data="getDelivery(scope.row)"
            :show-header="false"
            row-class-name="popover-field"
            >
            <el-table-column
              prop="name"
              align="center"
              width="180"
              >
            </el-table-column>
            <el-table-column
              prop="data"
              width="300"
              >
              <template slot-scope="scope">
                <div
                  class="allow-click-copy"
                  @click="doCopy(scope.row['data'])"
                  >
                  {{ scope.row['data'] }}
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-button circle slot="reference">
            <svg-icon
              icon-class="delivery_dining_white_24dp"
              >
            </svg-icon>
          </el-button>
        </el-popover>
      </div>
      <div
        v-if="scope.row.sales_mode === salesMode.Cert"
        >
        <div
          v-if="scope.row.cert_status === 0"
          >
          <el-tooltip
            class="item"
            effect="dark"
            :content="$t('api.certFileUpload')"
            :open-delay="openDelay"
            placement="top"
            >
            <el-upload
              action="./cert"
              :before-upload="(file) => { return beforeUpload(file, scope.row) }"
              :show-file-list="false"
              >
              <el-button
                size="small"
                type="primary"
                icon="el-icon-upload"
                circle
                :loading="uploadCertLoading"
                :disabled="scope.row.status !== 2"
                >
              </el-button>
            </el-upload>
          </el-tooltip>
        </div>
        <div
          v-else-if="scope.row.cert_status === 1"
          >
          <el-tooltip
            class="item"
            effect="dark"
            :content="$t('api.certFileDownload')"
            :open-delay="openDelay"
            placement="top"
            >
            <el-button
              size="small"
              type="success"
              icon="el-icon-download"
              circle
              @click="downloadCert(scope.row.cert_file_path)"
              >
            </el-button>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$t('api.certFileDelete')"
            :open-delay="openDelay"
            placement="top"
            >
            <el-button
              size="small"
              type="danger"
              icon="el-icon-delete"
              circle
              :loading="delCertLoading"
              @click="delCert(scope.row)"
              >
            </el-button>
          </el-tooltip>
        </div>
      </div>
      <div
        v-else-if="scope.row.sales_mode === salesMode.Movie"
        >
        <el-tooltip
          class="item"
          effect="dark"
          :content="movieBookingTime(scope.row)"
          :open-delay="openDelay"
          placement="top"
        >
          <el-tag
            class="allow-click-copy"
            @click="doCopy(scope.row.movie_booking_num)"
            :type="($moment(scope.row.booking_time) <= $moment()) ? 'success' : 'info'"
            effect="plain"
            >
            <svg-icon
              icon-class="movie_black_24dp"
              >
            </svg-icon>
            {{ scope.row.movie_booking_num }}
          </el-tag>
        </el-tooltip>
      </div>
      <div
        v-else-if="scope.row.sales_mode !== salesMode.Delivery"
      >
        <el-tooltip
          class="item"
          effect="dark"
          :open-delay="openDelay"
          placement="top"
        >
          <div slot="content">
            <span v-if="scope.row.no_show_at">
              {{ noShow(scope.row) }}
              <br v-if="scope.row.used_time" />
              <span v-if="scope.row.used_time">
                {{ usedTime(scope.row) }}
              </span>
            </span>
            <span v-else>
              {{ usedTime(scope.row) }}
            </span>
          </div>
          <el-tag
            class="allow-click-copy"
            @click="doCopy(scope.row.redeem_code)"
            :type="tagType(scope.row)"
            effect="plain"
          >
            <i
              v-if="scope.row.no_show_at !== null"
              class="el-icon-s-release"
            ></i>
            <i
              v-else-if="scope.row.used_time !== null"
              class="el-icon-check"
            ></i>
            {{ scope.row.redeem_code }}
          </el-tag>
        </el-tooltip>
      </div>
    </template>
  </el-table-column>
</template>

<script>

import { doCopy } from '@/utils/copy'
import { updateFilter } from '@/utils/filter'
import { getLabelText, getMap } from '@/utils/i18n'
import { getTimeText } from '@/utils/time'
import { uploadCertFile, deleteCert } from '@/api/orders/orders'
import {
  ProductSalesMode
} from '@/enums'

export default {
  name: 'redeem-code',
  props: {
    value: null,
    base: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    hasDesc: {
      type: Boolean,
      default: false
    },
    openDelay: {
      type: Number,
      default: 500
    },
    prop: {
      type: String
    },
    getList: {
      type: Function
    }
  },
  data () {
    return {
      val: this.value,
      salesMode: ProductSalesMode,
      filterName: 'redeem_status',
      filteredValue: [],
      uploadCertLoading: false,
      delCertLoading: false
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.updateFilter(this.filterName)
    })
  },
  computed: {
    usedTimeFilter () {
      return [
        {
          text: this.getLabelText(this.base, 'redeemed'),
          value: 'redeemed'
        },
        {
          text: this.getLabelText(this.base, 'unredeemed'),
          value: 'unredeemed'
        },
        {
          text: this.getLabelText(this.base, 'no_show'),
          value: 'no_show'
        }
      ]
    },
    label () {
      return this.getLabelText(this.base, 'redeem_status')
    }
  },
  methods: {
    doCopy,
    uploadCertFile,
    deleteCert,
    getMap,
    getLabelText,
    getTimeText,
    updateFilter,
    getRowData (row, field, isTime) {
      return {
        name: this.getLabelText(this.base, field),
        data: isTime
          ? this.getTimeText(row[field], row.tz_location || true)
          : row[field]
      }
    },
    getRowMap (row, field, mapName) {
      let m = this.getMap(mapName).filter((el) => {
        return el.value === row[field]
      })
      return {
        name: this.getLabelText(this.base, mapName),
        data: m[0] ? m[0].label : ''
      }
    },
    getDelivery (row) {
      let arr = [
        this.getRowData(row, 'orders_delivery_id'),
        this.getRowMap(row, 'delivery_status', 'deliveryStatus'),
        this.getRowMap(row, 'courier_type', 'courierType'),
        this.getRowData(row, 'delivery_id'),
        this.getRowData(row, 'delivery_uuid'),
        this.getRowData(row, 'courier_name'),
        this.getRowData(row, 'courier_phone'),
        this.getRowData(row, 'courier_pickup_time', true),
        this.getRowData(row, 'courier_pickup_at', true),
        this.getRowData(row, 'receiver_name'),
        this.getRowData(row, 'receiver_phone'),
        this.getRowData(row, 'receiver_address'),
        this.getRowData(row, 'receiver_pickup_time', true),
        this.getRowData(row, 'receiver_pickup_at', true)
      ]
      return arr
    },
    tagType (row) {
      return (row.used_time !== null) ? 'success' : 'info'
    },
    noShow (row) {
      if (row.no_show_at !== null) {
        return `${this.$t('api.orders.fields.no_show.label')}: ${this.getTimeText(row.no_show_at, row.tz_location)}`
      }
    },
    usedTime (row) {
      if (row.used_time !== null) {
        return `${this.$t('api.orders.fields.used_time.label')}: ${this.getTimeText(row.used_time, row.tz_location || true)}`
      }
      return this.$t('api.orders.fields.used_time.placeholder')
    },
    movieBookingTime (row) {
      return (this.$moment(row.booking_time) >= this.$moment()) ? this.$t('api.orders.fields.movie_booking_time.placeholder')
        : this.$t('api.orders.fields.movie_booking_time.label') + ': ' +
        this.getTimeText(row.booking_time, row.tz_location || true)
    },
    onInput () {
      this.$emit('input', this.val)
    },
    beforeUpload (file, row) {
      let data = new FormData()
      data.append('files', file, file.name)
      this.uploadCertLoading = true
      this.uploadCertFile(row.id, data).then(response => {
        this.$message({
          message: this.$t('api.fileUploadSuccess'),
          type: 'success',
          duration: 2000
        })
        this.getList()
      }).catch(err => {
        console.log(err)
      }).then(() => {
        this.uploadCertLoading = false
      })
      return false
    },
    delCert (row) {
      this.$confirm(this.$t('api.delConfirmMsg', {
        id: row.id,
        name: row.cert_file_path,
        idText: 'ID',
        dataText: this.$t('api.certFile')
      }), this.$t('api.delConfirmTitle'), {
        confirmButtonText: this.$t('api.confirmBtn'),
        cancelButtonText: this.$t('api.cancelBtn'),
        confirmButtonClass: 'el-button--danger',
        type: 'warning',
        dangerouslyUseHTMLString: true
      }).then(() => {
        this.delCertLoading = true
        this.deleteCert(row.cert_id).then(response => {
          this.$message({
            message: this.$t('api.certFileDeleteSuccess'),
            type: 'success',
            duration: 2000
          })
          this.getList()
        }).catch(err => {
          console.log(err)
        }).then(() => {
          this.delCertLoading = false
        })
      }).catch(err => {
        console.log(err)
      })
    },
    downloadCert (path) {
      var url = 'https://cdn.myfunnow.com/' + path
      var fileName = url.substring(url.lastIndexOf('/') + 1)
      var anchor = document.createElement('a')
      anchor.href = url
      anchor.target = '_blank'
      anchor.download = fileName
      anchor.click()
    }
  },
  watch: {
    value (newValue) {
      this.val = newValue
    },
    '$route.query' () {
      this.updateFilter(this.filterName)
    }
  }
}
</script>
